import { http } from './http';

export interface ApiDrawer {
  id: number;
  drawerName: string;
  drawerOrder?: number | null;
  drawerDescription?: string;
  drawerFolderFieldModelId?: number;
  drawerDocumentFieldModelId?: number;
  /** 0 = none, 1 = coding */
  metadataOption?: 0 | 1 | number;
}

function normalizeDrawer(d:any): ApiDrawer {
  // Enforce camelCase contract (API is camelCase)
  if (d.metadataOption === undefined || d.metadataOption === null) d.metadataOption = 0;
  if (d.drawerOrder === undefined) d.drawerOrder = (d?.DrawerOrder === undefined ? undefined : d?.DrawerOrder);
  return d as ApiDrawer;
}

export async function getDrawers(): Promise<ApiDrawer[]> { const data = await http<any[]>('/api/drawer'); return Array.isArray(data)? data.map(normalizeDrawer):[]; }
export async function addDrawer(drawer: Omit<ApiDrawer,'id'>): Promise<ApiDrawer> { return normalizeDrawer(await http('/api/drawer',{method:'POST', json:drawer})); }
export async function updateDrawer(id:number, drawer: Omit<ApiDrawer,'id'>): Promise<void> { await http(`/api/drawer/${id}`,{method:'PUT', json:drawer}); }
export async function deleteDrawer(id:number): Promise<void> { await http(`/api/drawer/${id}`,{method:'DELETE'}); }
